import moment from "moment";

export const calculateDateDifference = (date1: Date, date2: Date) => {
    const fecha1 = moment(date1.toISOString().substring(0, 10).concat('T00:00'));
    const fecha2 = moment(date2.toISOString().substring(0, 10).concat('T00:00'));
    // console.log('xxxxxxxxxxxx fecha 1', fecha1, date1, date1.toISOString())
    // console.log('xxxxxxxxxxxx fecha 2', fecha2, date2, date2.toISOString())
    return  fecha2.diff(fecha1, 'days');
};

export const calculateDateDifferenceMinutes = (date1: Date, date2: Date) => {
    const fecha1 = moment(date1.toISOString());
    const fecha2 = moment(date2.toISOString());
    // console.log('xxxxxxxxxxxx fecha 1', fecha1, date1, date1.toISOString())
    // console.log('xxxxxxxxxxxx fecha 2', fecha2, date2, date2.toISOString())
    return  fecha2.diff(fecha1, 'minutes');
};

export function isValidDate(date: any): date is Date {
    return date instanceof Date && !isNaN(date.getTime());
}

export const formatTypeDate = (date: Date | string | undefined) => {
    if (date instanceof Date) {
        return date
    } else if (typeof date === 'string') {
        return new Date(date.toString().length < 19 ? date.toString().substring(0, 16) : date.toString().substring(0, 19))
    }
    return undefined
}

export const formatDateString = (date: Date | string | undefined) => {
    let dateAux
    if (date instanceof Date) {
        dateAux = date
    } else if (typeof date === 'string') {
        dateAux = new Date(date.toString().length < 19 ? date.toString().substring(0, 16) : date.toString().substring(0, 19))
    }
    if (dateAux) {
        const day = String(dateAux.getDate()).padStart(2, '0');
        const month = String(dateAux.getMonth() + 1).padStart(2, '0');
        const year = dateAux.getFullYear();
        return `${day}/${month}/${year}`;
    }
    return '-'
}

export const formatDateStringBackend = (date: Date | string | undefined) => {
    let dateAux
    if (date instanceof Date) {
        dateAux = date
    } else if (typeof date === 'string') {
        dateAux = new Date(date)
    }
    if (isValidDate(dateAux)) {
        const day = String(dateAux.getDate()).padStart(2, '0');
        const month = String(dateAux.getMonth() + 1).padStart(2, '0');
        const year = dateAux.getFullYear();
        return `${day}-${month}-${year}`;
    }
    return undefined
}

export const formatDateHoursString = (date: Date | string | undefined) => {
    let dateAux
    if (date instanceof Date) {
        dateAux = date
    } else if (typeof date === 'string') {
        dateAux = new Date(date)
    }
    if (isValidDate(dateAux)) {
        const day = String(dateAux.getDate()).padStart(2, '0');
        const month = String(dateAux.getMonth() + 1).padStart(2, '0');
        const year = dateAux.getFullYear();
        const hours = String(dateAux.getHours()).padStart(2, '0');
        const minutes = String(dateAux.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
    return '-'
}

export const formatDateHoursStringT = (date: Date | string | undefined) => {
    let dateAux
    if (date instanceof Date) {
        dateAux = date
    } else if (typeof date === 'string') {
        dateAux = new Date(date)
    }
    if (isValidDate(dateAux)) {
        const day = String(dateAux.getDate()).padStart(2, '0');
        const month = String(dateAux.getMonth() + 1).padStart(2, '0');
        const year = dateAux.getFullYear();
        const hours = String(dateAux.getHours()).padStart(2, '0');
        const minutes = String(dateAux.getMinutes()).padStart(2, '0');
        const seconds = String(dateAux.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }
    return '-'
}

export const formatDateHoursStringTDB = (date: Date | string | undefined) => {
    let dateAux2
    if (date instanceof Date) {
        dateAux2 = date
    } else if (typeof date === 'string') {
        dateAux2 = new Date(date)
    }
    if (isValidDate(dateAux2)) {
        const day = String(dateAux2.getDate()).padStart(2, '0');
        const month = String(dateAux2.getMonth() + 1).padStart(2, '0');
        const year = dateAux2.getFullYear();
        const hours = String(dateAux2.getHours()).padStart(2, '0');
        const minutes = String(dateAux2.getMinutes()).padStart(2, '0');
        const seconds = String(dateAux2.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000-05:00`;
    }
    return undefined
}

export const formatDateHoursString2 = (date: string) => {
    const [datePart, timePart] = date.split(', ');
    const [day, month, year] = datePart.split('/');
    const numericMonth = Number(month);
    const [hours, minutes, seconds] = timePart.split(':');
    const parsedDate = new Date(Number(year), numericMonth - 1, Number(day), Number(hours), Number(minutes), Number(seconds));
    if (parsedDate) {
        const day = String(parsedDate.getDate()).padStart(2, '0');
        const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
        const year = parsedDate.getFullYear();
        const hours = String(parsedDate.getHours()).padStart(2, '0');
        const minutes = String(parsedDate.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year}-${hours}-${minutes}`;
    }
    return '-'
}

export const formatDateBackendString = (date: Date | undefined) => {
    if (date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}/${month}/${day}`;
    }
    return undefined
}


export const currentDateEcuadorFormat = (): String => {
    const now = new Date();
    const timeZone = 'America/Guayaquil';

    const options: Intl.DateTimeFormatOptions = {
        timeZone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hourCycle: 'h23'
    };

    const formatter = new Intl.DateTimeFormat([], options);
    const formattedDate = formatter.format(now);
    return formatDateHoursString2(formattedDate);
};

const parseFormattedDate = (formattedDate: string): Date => {
    const [day, month, year, time] = formattedDate.split(/[/,]/);
    const [hour, minute, second] = time.split(':');

    return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), parseInt(hour, 10), parseInt(minute, 10), parseInt(second, 10));
};
